import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { Account, LoaderFullScreen } from '@sm360/widget-commons-general';
import { Wizard } from '@sm360/widget-commons-forms';
import { Vehicle, Quote } from '@sm360/widget-commons-vehicle';

import TradeInModel from 'trade-in/model/TradeInModel.js';
import TradeInService from 'trade-in/services/TradeInService/TradeInService.js';
import VehicleForm from 'trade-in/components/VehicleForm/VehicleForm.jsx';
import CanadianBlackBookEstimate from 'trade-in/components/CanadianBlackBookEstimate/CanadianBlackBookEstimate.jsx';

import 'trade-in/components/InstantEstimateWrapper/InstantEstimateWrapper.scss';

class InstantEstimateWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isScreenLock: false,
            tradeInVehicle: props.tradeInVehicle,
            tradeInValues: null,
            account: new Account(),
        };

        this.getSteps = this.getSteps.bind(this);
        this.toggleScreenLock = this.toggleScreenLock.bind(this);
        this.updateLead = this.updateLead.bind(this);
        this.updateTradeInVehicle = this.updateTradeInVehicle.bind(this);
    }

    getSteps() {
        const steps = [];
        steps.push(({ goNextStep }) => (
            <VehicleForm
                autofillTradeInVehicleFromAccount={false}
                account={this.state.account}
                updateAccount={(account) => this.setState({ account })}
                lockScreen={this.toggleScreenLock}
                onFormSubmit={(data) => this.setState(data, goNextStep)}
                onTradeInVehicleUpdated={this.updateTradeInVehicle}
                tradeInVehicle={this.state.tradeInVehicle}
                isRenderedInModal
                useCBB
                quote={this.props.quote}
            />
        ));

        steps.push(({ goPreviousStep, goNextStep }) => (
            <CanadianBlackBookEstimate
                account={this.state.account}
                tradeInVehicle={this.state.tradeInVehicle}
                goToOfficialTradeInForm={goNextStep}
                backToVehicleForm={goPreviousStep}
                tradeInValues={this.state.tradeInValues}
                handleEstimateChange={this.updateLead}
                isOfficialTradeInActivated={this.props.isShowroomV2Enabled}
                isShowroomV2Enabled={this.props.isShowroomV2Enabled}
                isRenderedInModal
            />
        ));

        return steps;
    }

    toggleScreenLock() {
        this.setState((prevState) => {
            return { isScreenLock: !prevState.isScreenLock };
        });
    }

    updateTradeInVehicle(tradeInVehicle, onStateSet) {
        this.setState((oldState) => {
            return { ...oldState, tradeInVehicle };
        }, onStateSet);
    }

    updateLead(amount, profile) {
        const updatedTradeInModel = new TradeInModel({
            leadId: this.state.leadId,
            tradeInVehicle: this.state.tradeInVehicle,
            estimation: {
                amount,
                high: this.state.tradeInValues.high,
                low: this.state.tradeInValues.low,
            },
            profile,
        });
        return TradeInService.saveTradeIn(updatedTradeInModel, this.props.quote);
    }

    render() {
        return (
            <div className="TradeIn__wrapper">
                <LoaderFullScreen show={this.state.isScreenLock} message={LocaleService.t('TRADE_IN.SCREEN_LOCKED')}>
                    <Wizard steps={this.getSteps()} parentSelector=".TradeIn__wrapper" />
                </LoaderFullScreen>
            </div>
        );
    }
}

InstantEstimateWrapper.propTypes = {
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel).isRequired,
    isShowroomV2Enabled: PropTypes.bool.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
};

InstantEstimateWrapper.displayName = 'InstantEstimateWrapper';

export default InstantEstimateWrapper;



// WEBPACK FOOTER //
// ./src/components/InstantEstimateWrapper/InstantEstimateWrapper.jsx